import React, { useEffect, useState } from "react";
import LoginHeader from "./LoginHeader";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";
import imgurl from "../../assets/images/imgurl";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import axios from "axios";
import API from "../../services/apiMiddleware";
import { setCommunityData } from "../../redux/actions/communityDetails";
import { useDispatch } from "react-redux";
import { getRoleDetails, loginUrl } from "../../services/urls";
import { setRoleInfoData } from "../../redux/actions/roleInfo";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [responseError, setResponseError] = useState("");
  const [onFirstTimeLogin, setOnFirstTimeLogin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const [formValid, setFormValid] = useState(false);
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    document.cookie = `auth-token = expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;Secure;SameSite=Strict`;
    // localStorage.removeItem("auth-token");
  }, []);

  const handleClearEmail = () => {
    setEmail("");
    setEmailError("");
    setIsEmailValid(false);
  };

  const errorClass = (error) => {
    return !error ? "" : "is-invalid";
  };

  const validateField = (fieldName, value) => {
    let emailValid,
      passwordValid,
      fieldValidationErrors = {};
    switch (fieldName) {
      case "email":
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid ? "" : "Email is invalid";
        setEmailError(fieldValidationErrors.email);
        setIsEmailValid(emailValid);
        break;
      case "password":
        // passwordValid = value.length >= 6;
        // fieldValidationErrors.password = passwordValid ? '' : 'Password is too short, atleast 6 character';

        // passwordValid  = value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/i);
        passwordValid = value.match(
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@&_!/.$#]).{8,30}$/
        );
        fieldValidationErrors.password = passwordValid
          ? ""
          : "Enter valid password format";
        setPasswordError(fieldValidationErrors.password);
        setIsPasswordValid(passwordValid);
        break;
      default:
        break;
    }
  };

  const handleUserInput = ({ target }) => {
    let { name, value } = target;

    if (name === "field-email-x") {
      setEmail(value);
      if (value === "") {
        setEmailError("");
        setIsEmailValid(false);
      } else {
        validateField("email", value);
      }
    } else {
      // Handle password input
      setPassword(value);
    }
  };

  const handleSubmit = async () => {
    if (isEmailValid && isPasswordValid) {
      let requestOptions = {
        userName: email,
        password: password,
      };

      API.post(loginUrl, requestOptions)
        .then(({ data }) => {
          setLoading(true);
          let loginUrl = data.data;
          if (loginUrl) {
            // getRoleDetailsData(loginUrl.communityId, loginUrl.roleId);
            let bFirstTimelogin = loginUrl.firstTimeLogin;
            if (bFirstTimelogin) {
              setOnFirstTimeLogin(loginUrl);
            } else {
              dispatch(setCommunityData(loginUrl));
              localStorage.setItem("communityData", JSON.stringify(loginUrl));
            }
          } else {
            setResponseError(loginUrl.message);
          }
          setLoading(false);
        })
        .catch((error) => {
          setResponseError("Invalid Credential");
          console.error("Error fetching overview data:", error);
        });
    }
  };
  const errorResp = responseError ? (
    <div
      className="alert-danger"
      dangerouslySetInnerHTML={{ __html: responseError }}
    ></div>
  ) : (
    ""
  );

  return (
    <div className="loginui">
      {/* <Loader isLoading={loading} /> */}
      <LoginHeader />
      <Grid container spacing={2}>
        <Grid size={3}></Grid>
        <Grid size={6} className="logingrid">
          <div className="logincard">
            <Card className="p-4 userloginCard">
              <CardContent>
                {errorResp}
                <Typography className="logintxt">Login</Typography>
                <Typography className="signintext">
                  Sign-in to your community
                </Typography>
                <Grid container spacing={2} className="userfield mb-3">
                  <Grid size={1}>
                    <img src={imgurl.user} alt="User" />
                  </Grid>
                  <Grid size={11} className="userinputfield">
                    <TextField
                      className={`form-control email-input ${errorClass(
                        emailError
                      )}`}
                      type="email"
                      id="outlined-basic"
                      name="field-email-x"
                      placeholder="Email"
                      variant="outlined"
                      value={email}
                      onChange={handleUserInput}
                      autoFocus={true}
                    />
                    {email && !isEmailValid && (
                      <button
                        type="button"
                        className="btn btn-link"
                        onClick={handleClearEmail}
                        style={{
                          position: "absolute",
                          top: "20px",
                          right: "12px",
                          color: "#f86c6b",
                          transform: "translateY(-50%)",
                          zIndex: 10,
                          background: "transparent",
                          border: "none",
                          padding: "0",
                          cursor: "pointer",
                          boxSizing: "border-box",
                        }}
                      >
                        <img
                          src={imgurl.close}
                          alt="close"
                          style={{ width: "12px" }}
                        />
                      </button>
                    )}
                    <em className="invalid-feedback">{emailError}</em>
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="paaswordfield mb-4">
                  <Grid size={1}>
                    <img src={imgurl.fingerprint} alt="Fingerprint" />
                  </Grid>
                  <Grid size={11} className="passwdgrid">
                    <TextField
                      type={isRevealPwd ? "text" : "password"}
                      id="outlined-password-input"
                      placeholder="Password"
                      name="field-password-x"
                      value={password}
                      onChange={handleUserInput}
                      autoComplete="new-password"
                      className={`form-control  ${errorClass(passwordError)}`}
                    />
                    <div className="eyecss">
                      <img
                        src={isRevealPwd ? imgurl.openEye : imgurl.closedEye}
                        alt="Eye"
                        onClick={() =>
                          setIsRevealPwd((prevState) => !prevState)
                        }
                      />
                    </div>
                  </Grid>
                </Grid>
                <Button
                  variant="contained"
                  className="loginButton"
                  onClick={handleSubmit}
                >
                  Login
                </Button>
              </CardContent>
            </Card>
          </div>
        </Grid>
        <Grid size={3}></Grid>
      </Grid>
    </div>
  );
};

export default Login;
